<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path
      d="M10 0L14.2426 4.24264L12.8284 5.65685L10 2.82843L7.17157 5.65685L5.75736 4.24264L10 0ZM0 10L4.24264 5.75736L5.65685 7.17157L2.82843 10L5.65685 12.8284L4.24264 14.2426L0 10ZM20 10L15.7574 14.2426L14.3431 12.8284L17.1716 10L14.3431 7.17157L15.7574 5.75736L20 10ZM10 12C8.8954 12 8 11.1046 8 10C8 8.8954 8.8954 8 10 8C11.1046 8 12 8.8954 12 10C12 11.1046 11.1046 12 10 12ZM10 20L5.75736 15.7574L7.17157 14.3431L10 17.1716L12.8284 14.3431L14.2426 15.7574L10 20Z"
    />
  </svg>
</template>
